import checkStatus from '../../../utils/checkStatus.js';
import * as constants from './small-template-list-constants';
export function clearStore() {
  return { type: constants.CLEAR_STORE };
}

export function getTemplatesForImport(locationId, locationName) {
  return dispatch => {
    dispatch({ type: constants.GETTING_TEMPLATES });
    return fetch(`/proxy/contracting/location/${locationId}/templates?locationName=${locationName}`, {
      method: 'get',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
    })
      .then(checkStatus)
      .then(res => res.json())
      .then(({ templates, templatesForCC }) => dispatch({ type: constants.POPULATE_REDUCER, payload: { templates, templatesForCC, locationName } }))
      .catch(() => dispatch({ type: 'SHOW_CONTRACTING_ERROR_STRING', payload: 'Getting templates failed' }));
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/contracting/small-template-list/small-template-list-actions.js